import React, { useState, useRef } from "react"

import useProgress from "../../hooks/useProgress"

import { Container, CloseButton, ArrowIcon, NetworkAdUnit } from "./styles"

const BottomStickyAd = ({ article }) => {
  const { nsfw } = article

  // closed state:
  //  - has been closed because we scrolled to a specific point on the page
  const closedRef = useRef(false)
  // hidden state:
  //  - ad has been manually closed by clicking on the close button
  //  - ad container is removed completely
  const [isHidden, setHidden] = useState(false)

  const handleHide = (event) => {
    if (event.type?.toLowerCase() === "click" || event.code === "Enter" || event.code === "Space") {
      event.preventDefault()
      closedRef.current = true
      setHidden(true)
    }
  }

  useProgress((currentProgress) => {
    if (!closedRef.current) {
      closedRef.current = currentProgress > 70
      setHidden(currentProgress > 70)
    }
  })

  return (
    !isHidden && (
      <Container>
        <CloseButton onClick={handleHide} onKeyUp={handleHide} tabIndex={0}>
          Close Banner
          <ArrowIcon id="greater-than-icon" width="9" height="16" />
        </CloseButton>
        <NetworkAdUnit unitName="Desktop_Bottom_Strip" nsfw={nsfw} />
      </Container>
    )
  )
}

export default BottomStickyAd
